import { useEffect } from 'react'
import posthog from 'posthog-js'
import { useUIStore } from '@/stores/uiStore'

const POSTHOG_KEY = 'phc_9SOz0QMW0CNuU9j8AuJtOOiIbKOxARYggDedIiUwYY'
const POSTHOG_HOST = 'https://us.i.posthog.com'

// Initialize PostHog
export function initPostHog() {
  if (typeof window !== 'undefined' && !posthog.__loaded) {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      // Capture pageviews automatically
      capture_pageview: true,
      // Capture pageleaves for session duration
      capture_pageleave: true,
      // Enable session recording
      disable_session_recording: false,
      // Respect Do Not Track
      respect_dnt: true,
      // Persistence
      persistence: 'localStorage+cookie',
      // Autocapture clicks, inputs, etc.
      autocapture: true,
      // Mask sensitive inputs
      mask_all_text: false,
      mask_all_element_attributes: false,
    })
  }
}

// PostHog Provider component for page tracking
export function PostHogProvider({ children }: { children: React.ReactNode }) {
  const currentPage = useUIStore((state: { currentPage: string }) => state.currentPage)
  const activeTab = useUIStore((state: { activeTab: string }) => state.activeTab)

  // Initialize on mount
  useEffect(() => {
    initPostHog()
  }, [])

  // Track page changes
  useEffect(() => {
    if (posthog.__loaded) {
      posthog.capture('$pageview', {
        page: currentPage,
        tab: activeTab,
        $current_url: window.location.href,
      })
    }
  }, [currentPage, activeTab])

  return <>{children}</>
}

// Export posthog instance for direct usage
export { posthog }
